import { ApolloProvider } from "@apollo/client/react";
import { DarkTheme, ThemeProvider } from "@react-navigation/native";
import { Stack } from "expo-router";
import { Platform } from "react-native";

import "@/atoms/events";
import "@/atoms/profile";
import { useSessionSync } from "@/atoms/session";
import StripeProvider from "@/components/stripe-provider";
import { colors } from "@/constants/colors";
import { apolloClient } from "@/utils/apollo";
import { BugsnagErrorBoundary } from "@/utils/bugsnag";

const WebDarkTheme = {
  ...DarkTheme,
  colors: {
    ...DarkTheme.colors,
    background: colors.transparent,
    card: colors.transparent,
  },
};

export default function RootLayout() {
  useSessionSync();
  const isWeb = Platform.OS === "web";

  const darkTheme = isWeb ? WebDarkTheme : DarkTheme;

  return (
    <BugsnagErrorBoundary>
      <ApolloProvider client={apolloClient}>
        <StripeProvider>
          <ThemeProvider value={darkTheme}>
            <Stack
              screenOptions={
                isWeb
                  ? { contentStyle: { backgroundColor: "transparent" } }
                  : {}
              }
            >
              <Stack.Screen name="index" options={{ headerShown: false }} />
              <Stack.Screen name="privacy" options={{ headerShown: false }} />
              <Stack.Screen name="terms" options={{ headerShown: false }} />
              <Stack.Screen name="e/index" options={{ headerShown: false }} />
              <Stack.Screen name="e/[slug]" options={{ headerShown: false }} />
            </Stack>
          </ThemeProvider>
        </StripeProvider>
      </ApolloProvider>
    </BugsnagErrorBoundary>
  );
}
